import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/context/AuthContext';
import { StockInconsistencySummaryProvider } from './components/context/StockInconsistencySummaryContext';
import { OrderSummaryProvider } from './components/context/OrderSummaryContext';
import Home from './components/home/Home';
import Login from './components/home/Login';
import Signup from './components/home/Signup';
import NewAccount from './components/account/NewAccount';  // Import the new component
import Orders from "./components/orders/Orders";
import StockMovementsDashboard from './components/stock/StockMovementsDashboard';
import StockInconsistenciesDashboard from './components/stock/StockInconsistenciesDashboard';
import UsersDashboard from './components/users/UsersDashboard';
import FeatureFlagsDashboard from './components/users/FeatureFlagsDashboard';
import NotificationsDashboard from './components/notifications/NotificationsDashboard';
import PrivateRoute from './components/misc/PrivateRoute';
import AppShell from './components/layout/AppShell';
import OperationsHomePage from './components/layout/OperationsHomePage';
import ChannelsPage from './components/layout/ChannelsPage';
import { useAuth } from './components/context/AuthContext';
import AnalyticsTracker from './components/analytics/AnalyticsTracker';

function AdminRoute({ children }) {
  const { isAdmin } = useAuth();

  return isAdmin() ? children : <Navigate to="/home" replace />;
}

function App() {
  return (
      <AuthProvider>
        <Router>
          <AnalyticsTracker />
          <Routes>
            <Route path='/' element={<Login />} />
            <Route path='/login' element={<Login />} />
            <Route path='/signup' element={<Signup />} />
            <Route
              element={(
                <PrivateRoute>
                  <StockInconsistencySummaryProvider>
                    <OrderSummaryProvider>
                      <AppShell />
                    </OrderSummaryProvider>
                  </StockInconsistencySummaryProvider>
                </PrivateRoute>
              )}
            >
              <Route path='/inicio' element={<OperationsHomePage />} />
              <Route path='/home' element={<Home />} />
              <Route path='/stock' element={<Home />} />
              <Route path='/publicaciones' element={<Home />} />
              <Route path='/precios' element={<Home />} />
              <Route path='/canales' element={<ChannelsPage />} />
              <Route path='/newAccount' element={<NewAccount />} />
              <Route path="/notifications" element={<NotificationsDashboard />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/ordenes" element={<Orders />} />
              <Route path="/stock-movements" element={<StockMovementsDashboard />} />
              <Route path="/movimientos" element={<StockMovementsDashboard />} />
              <Route path="/stock-inconsistencies" element={<StockInconsistenciesDashboard />} />
              <Route path='/users' element={<AdminRoute><UsersDashboard /></AdminRoute>} />
              <Route path='/feature-flags' element={<AdminRoute><FeatureFlagsDashboard /></AdminRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </AuthProvider>
  );
}

export default App;
